import { render, staticRenderFns } from "./Antrean.vue?vue&type=template&id=149a5044&"
import script from "./Antrean.vue?vue&type=script&lang=js&"
export * from "./Antrean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports